import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from "prop-types"

import Report from '../userPaygoInfoProfile/messaging/report.jsx';


class ClientReports extends Component {
    static propTypes = {
        profile_list: PropTypes.array.isRequired, // RESUME , LIST
        paygoID: PropTypes.string.isRequired
    };
    render (){

        return (
            <div>
                <Report {...this.props} />  
            </div>
                                
        )
    }
}

export default ClientReports;